var map = {
	"./Speech_bubbles_godville_1.webp": 55408,
	"./Speech_bubbles_godville_2.webp": 98237,
	"./Speech_bubbles_godville_3.webp": 73522,
	"./Speech_bubbles_godville_4.webp": 96175,
	"./Speech_bubbles_godville_5.webp": 21292,
	"./Speech_bubbles_godville_6.webp": 15561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69579;